import { CONTENT_FETCH_DONE, FETCH_STARTED, FETCH_FAILED } from '../actions/actionTypes'

const initialState = {
  title: '',
  introduction: 'not set',
  fullText: 'not set',
  contentTypeName: 'not set',
  author: '',
  published: new Date(0),
  eventDate: new Date(0),
  location: '',
  categories: [],
  attachments: [],
  relatedContents: [],
  keywords: [],
  fetching: false,
  error: ''
}

export const content = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case FETCH_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    case CONTENT_FETCH_DONE: {
      return {
        ...state,
        title: action.payload.data.title,
        author: action.payload.data.author,
        introduction: action.payload.data.introduction,
        fullText: action.payload.data.fullText,
        contentTypeName: action.payload.data.contentTypeName,
        published: action.payload.data.published,
        eventDate:  action.payload.data.eventDate,
        location:  action.payload.data.location,
        categories: action.payload.data.categories,
        documentTypes: action.payload.data.documentTypes,
        attachments: action.payload.data.attachments,
        relatedContents: action.payload.data.relatedContents,
        keywords: action.payload.data.keywords,
        fetching: false
      }
    }
    default:
      return state
  }
}
